import { WITHOUT_DATA } from "../models/rm-common-properties";
import { StringUtils } from "./string.utils";

/** The status fields that use WITHOUT_DATA instead of an empty value */
const obsolescenceStatusFieldNames = [
  "obsolescenceStatus",
  "obsolescenceStatus2years",
  "obsolescenceStatus4years",
  "obsolescenceStatus6years",
  "obsolescenceStatus8years"
];

export class ObsolescenceUtils {
  /**
   * Set the obsolescence statuses the user did not provide to WITHOUT_DATA, so
   * a part or a manufacturer is never saved with an empty status.
   */
  public static setStatusesWithoutData<T>(doc: T): T {
    obsolescenceStatusFieldNames.forEach((fieldName) => {
      if (StringUtils.isNullOrEmpty((doc as any)[fieldName])) {
        (doc as any)[fieldName] = WITHOUT_DATA;
      }
    });

    return doc;
  }
}
